import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

function ZipCodeInput({ value, onChange }) {
  const [zipCode, setZipCode] = useState(value);
  const [error, setError] = useState('');

  useEffect(() => {
    setZipCode(value);
  }, [value]);

  const validateZipCode = (zipCode) => {
    const regex = /^[0-9]{5}(-[0-9]{4})?$/;
    if (zipCode === '' || regex.test(zipCode)) {
      setError('');
      return true;
    } else {
      setError('Invalid zip code format. Expected: 12345 or 12345-6789');
      return false;
    }
  };

  const handleInputChange = (e) => {
    const { value } = e.target;
    // Allow only digits and a dash, disallowing letters and spaces
    let filteredValue = value.replace(/[^0-9-]/g, '');
  
    // Enforce that length can only exceed 5 if the 6th character is a dash
    if (filteredValue.length > 5 && filteredValue[5] !== '-') {
      filteredValue = filteredValue.slice(0, 5);
    } else if (filteredValue.length > 10) { // Maximum length check (5 digits, 1 dash, 4 digits)
      filteredValue = filteredValue.slice(0, 10);
    }
  
    // Prevent more than one dash or incorrect dash position
    const dashIndex = filteredValue.indexOf('-');
    if (dashIndex > 5 || (dashIndex !== -1 && filteredValue.length === 6)) { // Ensure dash is at position 6 if present
      filteredValue = filteredValue.slice(0, 6);
    } else if (dashIndex !== -1 && dashIndex < 5) { // If dash is not at position 6, remove it
      filteredValue = filteredValue.split('-').join('');
    }
  
    setZipCode(filteredValue);
  };

  const handleFinalChange = (e) => {
    // Call the passed onChange only if the final value is valid
    if (validateZipCode(zipCode)) {
      onChange(e);
    }
  };

  return (
    <div>
      <label htmlFor="zip_code" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Zip Code</label>
      <input
        type="text"
        id="zip_code"
        name="zip_code"
        value={zipCode}
        onChange={handleInputChange}
        onBlur={handleFinalChange}
        className={`bg-gray-50 border ${error ? 'border-red-500' : 'border-gray-300'} text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500`}
        placeholder="Zip Code"
      />
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
    </div>
  );
}

ZipCodeInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ZipCodeInput;
